/* MCC Global Search — uses native <dialog> showModal() for guaranteed top-layer rendering */
(function () {
  'use strict';

  var overlay   = document.getElementById('mcc-search');
  var input     = document.getElementById('mcc-search-input');
  var results   = document.getElementById('mcc-search-results');
  var closeBtn  = document.getElementById('mcc-search-close');
  var toggleBtn = document.getElementById('mcc-search-toggle');

  if (!overlay || !input) return;

  var debounceTimer = null;
  var lastQuery = '';

  // ── Open / Close ──────────────────────────────────────────
  function openSearch() {
    overlay.showModal();                          // native top-layer — nothing can cover this
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 60);
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
  }

  function closeSearch() {
    if (!overlay.open) return;
    overlay.close();
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
    lastQuery = '';
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  }

  // Toggle button (the search pill in the header)
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      overlay.open ? closeSearch() : openSearch();
    });
  }

  // Close button (✕ inside overlay)
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Close when clicking on the transparent dialog backdrop area
  // (clicks outside .mcc-search__inner land on the dialog element itself)
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeSearch();
  });

  // Native Escape key — dialog fires 'cancel'; we intercept to run our cleanup
  overlay.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeSearch();
  });

  // ── Search Input ──────────────────────────────────────────
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = input.value.trim();
      if (q.length > 0) {
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    }
  });

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(debounceTimer);
    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function () { fetchResults(q); }, 280);
  });

  // ── Fetch from Shopify Predictive Search API ──────────────
  function fetchResults(q) {
    results.innerHTML = '<p class="mcc-search__msg">Searching…</p>';

    var fields = 'title,product_type,variants.sku,tag,body,variants.title';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[options][fields]=' + fields
      + '&resources[options][unavailable_products]=last'
      + '&resources[limit]=20';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderResults(data, q); })
      .catch(function () {
        results.innerHTML = '<p class="mcc-search__msg">Something went wrong. Please try again.</p>';
      });
  }

  // ── Render ─────────────────────────────────────────────────
  function renderResults(data, q) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (products.length === 0) {
      results.innerHTML = '<p class="mcc-search__msg">No results found for "<strong>' + escHtml(q) + '</strong>"</p>';
      return;
    }

    var html = '';
    var qLower = q.toLowerCase();

    products.forEach(function (p) {
      var matchLabel = getMatchLabel(p, qLower);
      var imgHtml = p.featured_image && p.featured_image.url
        ? '<img class="mcc-search__item-img" src="' + p.featured_image.url + '&width=120" alt="' + escHtml(p.title) + '" loading="lazy">'
        : '<div class="mcc-search__item-img-placeholder">🎄</div>';

      var price = p.price ? formatMoney(p.price) : '';
      var comparePrice = p.compare_at_price_max && p.compare_at_price_max > p.price
        ? '<s style="opacity:0.4;font-weight:400;font-size:12px;">' + formatMoney(p.compare_at_price_max) + '</s> ' : '';

      var metaParts = [];
      if (p.product_type) metaParts.push(p.product_type);
      if (p.vendor)       metaParts.push(p.vendor);

      html += '<a class="mcc-search__item" href="' + p.url + '" tabindex="0">'
        + imgHtml
        + '<div class="mcc-search__item-body">'
        +   '<div class="mcc-search__item-title">' + highlightMatch(escHtml(p.title), qLower) + '</div>'
        +   (metaParts.length ? '<div class="mcc-search__item-meta">' + escHtml(metaParts.join(' · ')) + '</div>' : '')
        + '</div>'
        + '<div class="mcc-search__item-right">'
        +   (price ? '<div class="mcc-search__item-price">' + comparePrice + price + '</div>' : '')
        +   (matchLabel ? '<div class="mcc-search__item-match">' + matchLabel + '</div>' : '')
        + '</div>'
        + '</a>';
    });

    var footer = '<div class="mcc-search__footer">'
      + '<span class="mcc-search__footer-count">' + products.length + ' result' + (products.length !== 1 ? 's' : '') + '</span>'
      + '<a class="mcc-search__view-all" href="/search?type=product&q=' + encodeURIComponent(q) + '">View all results →</a>'
      + '</div>';

    results.innerHTML = html + footer;
  }

  // ── Helpers ────────────────────────────────────────────────
  function getMatchLabel(p, qLower) {
    var title = (p.title || '').toLowerCase();
    var type  = (p.product_type || '').toLowerCase();
    var sku   = '';
    if (p.variants) {
      p.variants.forEach(function (v) { if (v.sku) sku += v.sku.toLowerCase() + ' '; });
    }
    var tags = (p.tags || []).map(function (t) { return t.toLowerCase(); }).join(' ');
    var body = (p.body || p.body_html || '').toLowerCase().replace(/<[^>]+>/g, ' ');

    if (title.indexOf(qLower) > -1) return '';
    if (sku.indexOf(qLower)   > -1) return 'SKU match';
    if (tags.indexOf(qLower)  > -1) return 'Tag match';
    if (type.indexOf(qLower)  > -1) return 'Type match';
    if (body.indexOf(qLower)  > -1) return 'Description';
    return '';
  }

  function highlightMatch(htmlTitle, qLower) {
    var lower = htmlTitle.toLowerCase();
    var idx = lower.indexOf(qLower);
    if (idx === -1) return htmlTitle;
    return htmlTitle.slice(0, idx)
      + '<mark style="background:rgba(201,168,76,0.35);border-radius:2px;padding:0 1px;">'
      + htmlTitle.slice(idx, idx + qLower.length)
      + '</mark>'
      + htmlTitle.slice(idx + qLower.length);
  }

  function formatMoney(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
